import { useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { SampleDetailed, SampleReactionStatus, SampleStatus } from '../types'
import { SamplePauseModal } from './SamplePauseModal'
import { refetchFunc } from 'modules/domain/common/hooks'
import { useTranslation } from 'react-i18next'
import { SampleResumeModal } from './SampleResumeModal'
import { formatDuration } from 'date-fns'
import { ru } from 'date-fns/locale'

type Props = {
  sample: SampleDetailed
  refetch: refetchFunc
}
export const SamplePause = ({ sample, refetch }: Props) => {
  const { t } = useTranslation('samples')
  const [isPauseModalOpen, setIsPauseModalOpen] = useState(false)
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false)
  if (sample.status != SampleStatus.in_progress) {
    return null
  }
  let btn
  if (sample.reaction_status == SampleReactionStatus.paused) {
    let formatedTimeDelta = t('sampleReaction.expired')
    if (sample.time_left_for_reaction) {
      const hoursLeft = Math.trunc(sample.time_left_for_reaction / 60)
      const days = Math.trunc(hoursLeft / 24)
      const hours = hoursLeft % 24
      formatedTimeDelta = formatDuration({ days, hours: hours }, { locale: ru })
    }
    btn = (
      <AButton
        onClick={() => setIsResumeModalOpen(true)}
        analyticsPayload={{ id: sample.id.toString() }}
        size="medium"
        color="notify"
        id="resume"
      >
        {t('resume')} ({t('left')}: {formatedTimeDelta})
      </AButton>
    )
  } else {
    btn = (
      <AButton
        onClick={() => setIsPauseModalOpen(true)}
        analyticsPayload={{ id: sample.id.toString() }}
        size="medium"
        color="secondary"
        id="pauseModal"
      >
        {t('pause')}
      </AButton>
    )
  }

  return (
    <>
      {btn}
      {isPauseModalOpen && (
        <SamplePauseModal onClose={() => setIsPauseModalOpen(false)} refetch={refetch} sample={sample} />
      )}
      {isResumeModalOpen && (
        <SampleResumeModal onClose={() => setIsResumeModalOpen(false)} refetch={refetch} sample={sample} />
      )}
    </>
  )
}
